// extracted by mini-css-extract-plugin
module.exports = {"sales-page":"index_sales-page__1-UdR","course-catalog":"index_course-catalog__3m7b5","image":"index_image__t7BsS"};